import { Children, ComponentPropsWithoutRef } from "react";

import ModalLayout from "@/components/Layout/ModalLayout";
import { PropsWithRequiredChildren } from "@/types/common";
import { cn } from "@/utils/cn";

interface ModalContentProps extends ComponentPropsWithoutRef<"div"> {}

interface ReservationModalProps extends PropsWithRequiredChildren {
  onClose: () => void;
}

const Header = ({ children }: PropsWithRequiredChildren) => (
  <div className="flex h-20 shrink-0 flex-col justify-center gap-2 rounded-sm bg-primary px-6 text-xl font-light text-white md:h-32 md:px-8">
    {children}
  </div>
);

const Content = ({ children, className }: ModalContentProps) => (
  <div
    className={cn(
      "min-h-0 flex-1 overflow-y-auto p-4 md:max-h-[70vh]",
      className,
    )}
  >
    {children}
  </div>
);

const Footer = ({ children }: PropsWithRequiredChildren) => (
  <div className="flex h-fit shrink-0 items-center justify-center gap-4 pb-6 pt-3 md:pb-8 md:pt-4">
    {children}
  </div>
);

const ReservationModal = ({ children, onClose }: ReservationModalProps) => {
  const [headerChildren, contentChildren, footerChildren] =
    Children.toArray(children);

  return (
    <ModalLayout variant="primary" onClose={onClose}>
      {/* 모바일: 화면 폭에서 좌우 1rem 여백, 높이는 화면 안에 맞추고 내용만 스크롤.
          데스크톱은 기존처럼 내용 영역을 70vh 로 제한한다.
          dvh 미지원 브라우저(iOS 15.4 미만)를 위해 vh 값을 먼저 선언해 둔다. */}
      <div className="flex max-h-[calc(100vh-2rem)] w-[min(calc(100vw-2rem),507px)] flex-col supports-[height:100dvh]:max-h-[calc(100dvh-2rem)]">
        {headerChildren}
        {contentChildren}
        {footerChildren}
      </div>
    </ModalLayout>
  );
};

ReservationModal.Header = Header;
ReservationModal.Content = Content;
ReservationModal.Footer = Footer;

export default ReservationModal;
